
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.405.5c.053.004.066.003.119.012a.888.888 0 01.47.239l5.25 5.143c.037.038.047.046.079.088a.847.847 0 010 1.036c-.032.041-.042.05-.079.088l-5.25 5.143c-.039.035-.048.045-.09.077a.888.888 0 01-.905.09.865.865 0 01-.494-.686.843.843 0 01.173-.605c.032-.042.042-.05.078-.088L5.388 6.5.756 1.963l-.04-.043c-.034-.04-.044-.05-.073-.093a.85.85 0 01-.143-.5.862.862 0 01.726-.815c.053-.009.066-.008.12-.012h.059z","fill":"currentColor"}})])
          )
        }
      }
    